/**
 * How the visitor covers the route.
 * walk — the default city walk. transit — a day that leaves the city.
 */
export enum ReadyRouteMobilityEnum {
    WALK = 'walk',
    TRANSIT = 'transit',
}
